import { checkIsDirty } from "PFApp/helpers/activity_form/check_is_dirty";
import { stringify } from "PFCore/helpers/use_deterministic_stringify";
import { useMemo } from "react";
import { useFormContext } from "react-hook-form";

type UseIsFormChanged = {
  simplified?: boolean;
};

export const useIsFormChanged = ({ simplified }: UseIsFormChanged = {}) => {
  const {
    formState: { dirtyFields, isSubmitting }
  } = useFormContext();

  const isChanged = useMemo(() => {
    if (isSubmitting) {
      return false;
    }
    return checkIsDirty(dirtyFields, { simplified });
  }, [stringify(dirtyFields), isSubmitting, simplified]);

  return isChanged;
};
